import { key } from "./key";
var CryptoJS = require("crypto-js");

export const setLoginInfo = (data) => {
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
    localStorage.setItem('doctoraU', ciphertext);
    
}